import { debounce, get, includes, map, size } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { fetchSongs } from "../../actions/songs.actions";
import { SearchInput } from "../../components/searchBar";
import SongListItem from "../../components/searchBar/songListItem";
import styles from "./editPlaylistPage.module.scss";

import Button from "../../components/button/Button";
import userStore from "../../zustand/user.store";
import { downloadSongImage } from "../../helpers/generel.helpers";
import imageStore from "../../zustand/image.store";

const PlayListSearchSection = (props) => {
  const { addSong, alreadyAddedSongIds, isViewMode, setIsViewMode } = props;
  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));
  const { addImage } = imageStore((state) => ({
    addImage: state.addImage,
  }));

  const [isActive, setIsActive] = useState(false);
  const [songs, setSongs] = useState([]);

  const toCallOneTime = useRef(false);

  const handleSearchKeyChange = (e) => {
    const { value } = e.target;
    functionWithDebounce(value);
  };

  const functionToRun = async (val) => {
    const songs = await fetchSongs(val, userOffline);
    setSongs(songs);
  };

  const functionWithDebounce = useCallback(
    debounce((val) => functionToRun(val), 400),
    []
  );

  const downloadSongImages = useCallback(async () => {
    for (let index = 0; index < size(songs); index++) {
      if (index >= size(songs)) return;
      const imageToDownload = get(songs, `${index}.thumbnail_img`, "");

      try {
        const result = await downloadSongImage(imageToDownload);
        if (result) {
          addImage(imageToDownload);
        }
      } catch (error) {
        //
      }
    }
  }, [songs, addImage]);

  useEffect(() => {
    downloadSongImages();
  }, [downloadSongImages]);

  useEffect(() => {
    if (toCallOneTime.current) return;
    (async () => {
      toCallOneTime.current = true;

      const songs = await fetchSongs(userOffline);

      setSongs(songs);
    })();
  }, []);

  return (
    <div className={styles.right}>
      <div className={styles.songsContainerClassName}>
        <SearchInput
          onChange={handleSearchKeyChange}
          onFocus={() => setIsActive(true)}
          onBlur={() => setIsActive(false)}
          isActive={isActive}
        />
      </div>
      {isViewMode ? (
        <div
          className={styles.songsListContainer}
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Button
            onClick={() => {
              setIsViewMode(false);
            }}
          >
            Add More Songs
          </Button>
        </div>
      ) : (
        <div className={styles.songsListContainer}>
          {map(songs, (song, index) => {
            if (includes(alreadyAddedSongIds, song.id)) return null;
            return (
              <SongListItem
                key={song.id + "searcha bar song"}
                song={song}
                contentContianerClassName={styles.contentContianerClassName}
                songNameClassName={styles.songName}
                songArtistClassName={styles.songName}
                hasBtn
                onBtnClick={addSong}
                containerClassName={styles.songListItemContainer}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

PlayListSearchSection.propTypes = {
  addSong: PropTypes.func,
  alreadyAddedSongIds: PropTypes.array,
};

PlayListSearchSection.defaultProps = {
  addSong: () => {},
  alreadyAddedSongIds: [],
};

export default PlayListSearchSection;
